import { RestrictedAccountObjectFacade } from "../restricted-account-object/restricted-account-object.facade";
import { ControlApiFacade } from "./control.api-facade";
import { ControlStoreFacade } from "./control.store-facade";
import { Control } from "./control.model";

export class ControlFacade extends RestrictedAccountObjectFacade<Control, ControlApiFacade, ControlStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control.facade.ts